module.exports = __webpack_public_path__ + "static/media/daihan-sittin.441e7d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/daihan-sittin.png
// module id = 23
// module chunks = 0